import { useEffect, useRef, useState } from 'react';

import i18n from '~/locale';
import { ConversationSection } from '~/types/api.graphql';

import { ConversationEntityType } from '../AIInsightsModal/AIInsightsModal.utils';
import { useAIInsightsSidebar } from './AIInsightsSidebarContext';

export const useAITextArea = ({ section }: { section: ConversationSection; entityType: ConversationEntityType }) => {
  const { isOpen, clickCounterCTA } = useAIInsightsSidebar();
  const [inputValue, setInputValue] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const key = `aiInsights.prompts.${section as string}`;
    if (section && isOpen && textareaRef.current && i18n.exists(key)) {
      const value = textareaRef.current.value;
      const text = i18n.t(key);
      if (!value.includes(text)) {
        handleInputChange(value.concat((value ? '\n' : '') + text), true);
      }
    }
  }, [isOpen, section, textareaRef.current, clickCounterCTA]);

  const handleInputChange = (value: string, scrollAnimated = false) => {
    setInputValue(value);

    setTimeout(() => {
      const textarea = textareaRef.current;
      const lineHeight: number = parseFloat(getComputedStyle(textarea).lineHeight);
      const maxHeight: number = lineHeight * 5;
      const clampedHeight: number = Math.min(Math.max(textarea.scrollHeight, 32), maxHeight);
      textarea.style.height = `${clampedHeight}px`;
      textarea.style.maxHeight = `${Math.min(clampedHeight, maxHeight)}px`;
      if (scrollAnimated) {
        textareaRef.current.scrollTo({ top: textareaRef.current.scrollHeight, behavior: 'smooth' });
      } else {
        textarea.scrollTop = textarea.scrollHeight;
      }
    }, 0);
  };

  return { textareaRef, inputValue, setInputValue, handleInputChange };
};
